import { apiSendPostHogData } from "Root/api/apiCommon";

function sendPostHogDataHelper(event, properties) {
  const body = {"event": event, "properties": properties}
  apiSendPostHogData(body)
}

export default sendPostHogDataHelper;
